// extracted by mini-css-extract-plugin
module.exports = {"label":"row-field_label__HCjW2","value":"row-field_value__3Vc-5"};